import { DeflistNode } from './const';
const DEFAULT_PLACEHOLDERS = {
    Term: 'Definition term',
    Desc: 'Definition description',
};
export const getSpec = (opts, placeholder) => {
    var _a, _b, _c, _d;
    return ({
        [DeflistNode.List]: {
            group: 'block',
            content: `(${DeflistNode.Term} ${DeflistNode.Desc})+`,
            parseDOM: [{ tag: 'dl' }],
            toDOM() {
                return ['dl', 0];
            },
            selectable: true,
            allowSelection: true,
            complex: 'root',
        },
        [DeflistNode.Term]: {
            defining: true,
            group: 'block',
            content: 'inline*',
            parseDOM: [{ tag: 'dt' }],
            toDOM() {
                return ['dt', 0];
            },
            placeholder: {
                content: (_b = (_a = placeholder === null || placeholder === void 0 ? void 0 : placeholder[DeflistNode.Term]) !== null && _a !== void 0 ? _a : opts === null || opts === void 0 ? void 0 : opts.deflistTermPlaceholder) !== null && _b !== void 0 ? _b : DEFAULT_PLACEHOLDERS.Term,
                alwaysVisible: true,
            },
            selectable: false,
            allowSelection: false,
            complex: 'leaf',
        },
        [DeflistNode.Desc]: {
            defining: true,
            group: 'block',
            content: 'block+',
            parseDOM: [{ tag: 'dd' }],
            toDOM() {
                return ['dd', 0];
            },
            placeholder: {
                content: (_d = (_c = placeholder === null || placeholder === void 0 ? void 0 : placeholder[DeflistNode.Desc]) !== null && _c !== void 0 ? _c : opts === null || opts === void 0 ? void 0 : opts.deflistDescPlaceholder) !== null && _d !== void 0 ? _d : DEFAULT_PLACEHOLDERS.Desc,
                alwaysVisible: true,
            },
            selectable: false,
            allowSelection: false,
            complex: 'leaf',
        },
    });
};
